import http from '@/assets/js/common/http-common';

class StudentDataService {

    checkStudentAnswer(id) {
        return http.post('prova/aluno/checkStudentAnswer', {prova:id});
    }

    checkGroupAnswer(id) {
        return http.post('prova/aluno/checkGroupAnswer', {prova:id});
    }
    
    enterClassroom(data) {
        return http.post('prova/aluno/enterClassRoom', data);
    }

    getLider(id) {
        return http.post('prova/aluno/getLider', {id:id});
    }

    activeStatus() {
        return http.post('prova/aluno/activeStatus', null);
    }
  
    isTestActivated() {
        return http.post('prova/aluno/isTestActivated', null);
    }
    
    listClassrooms() {
        return http.post('prova/aluno/listClassRooms', null);
    }

    listStudents(id) {
        return http.post('prova/aluno/listStudents', {id:id});
    }

    listTests() {
        return http.post('prova/aluno/listTests', null);
    }

    studentTest(id) {
        return http.post('prova/aluno/studentTest', {id:id});
    }

    submitGroup(data) {
        return http.post('prova/aluno/submitGroup', data);
    }

    submitGroupAnswer(data) {
        return http.post('prova/aluno/submitGroupAnswer', data);
    }
    
    submitStudentAnswer(data) {
        return http.post('prova/aluno/submitStudentAnswer', data);
    }

}

export default new StudentDataService();
